import { TabsValue } from '../constants/tabs';

export const getPaginationTotalRowsByTabValue = ({
  tabValue,
  recruitmentCount,
  otherCount
}: {
  tabValue: string;
  recruitmentCount: number;
  otherCount: number;
}) => {
  switch (tabValue) {
    case TabsValue.RECRUITMENT:
      return recruitmentCount;
    case TabsValue.OTHER:
      return otherCount;
    default:
      return 0;
  }
};
